<template>
  <div class="usuarios">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Usuarios">
          <b-table 
              hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="usuarios" 
              :fields="usuariosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(admin)="data">
              {{ data.item.admin? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(confirmado)="data">
              {{ data.item.confirmado? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(inactivo)="data">
              {{ data.item.inactivo? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Usuario</b-dropdown-item>
                <b-dropdown-item 
                    v-if="!data.item.confirmado"
                    @click.stop="reenviar(data.item)">
                  <i class="fa fa-paper-plane-o"></i>Enviar Invitación</b-dropdown-item>
                <b-dropdown-item 
                    v-if="data.item.confirmado"
                    @click.stop="password(data.item)">
                  <i class="fa fa-unlock-alt"></i>Restablecer Contraseña</b-dropdown-item>
                <b-dropdown-item 
                    v-if="data.item.inactivo & data.item.confirmado"
                    @click.stop="activar(data.item)">
                  <i class="fa fa-user-plus"></i>Activar</b-dropdown-item>
                <b-dropdown-item 
                    v-if="!data.item.inactivo & data.item.confirmado"
                    @click.stop="inactivar(data.item)">
                  <i class="fa fa-user-times"></i>Inactivar</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="preregistroModal" 
        title="Nueva Cuenta"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-preregistro
        @close="closeRegistro">
      </app-preregistro>  
    </b-modal>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Preregistro from '../usuarios/Preregistro.vue';
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarios/getField',
  mutationType: 'usuarios/updateField',
});

export default {
  name: 'Usuarios',
  components: {
    appPreregistro: Preregistro,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      usuariosFields: [
        // {
        //   key: 'nombre',
        //   sortable: true
        // },
        {
          key: 'email',
          sortable: true
        },
        {
          key: 'nombreCompleto',
          sortable: true
        },
        {
          key: 'admin',
          label: 'Administrador',
          class: 'text-center'
        },
        {
          key: 'confirmado',
          class: 'text-center'
        },
        {
          key: 'inactivo',
          class: 'text-center'
        },        
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'usuarios',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'incluirInactivos'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('usuarios/getUsuarios')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    // consultar (item) {
    //   this.$router.push({ name: 'UsuarioDatos', 
    //                       params: { id: item.id }});
    // },
    agregar () {
      this.$refs.preregistroModal.show();
    },
    closeRegistro(registrado) {
      this.$refs.preregistroModal.hide();
      if (registrado) {
        this.getItems();
      }
    },    
    editar (item) {
      this.$router.push({ name: 'UsuarioABM', 
                          params: { id: item.id }});
    },
    activar (item) {
      this.showModalConfirm('¿Desea activar la cuenta de usuario seleccionada?', 
            this.activarUsuario.bind(this, item.id), 'Si', null, 'No');
    },
    activarUsuario (usuarioId) {
      this.showSpinner();
      this.$store.dispatch('usuario/activar', usuarioId)
        .then(() => {
          this.showModalMsj('La cuenta de usuario seleccionada se activó con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
    inactivar (item) {
      this.showModalConfirm('¿Desea inactivar la cuenta de usuario seleccionada?', 
            this.inactivarUsuario.bind(this, item.id), 'Si', null, 'No');
    },
    inactivarUsuario (usuarioId) {
      this.showSpinner();
      this.$store.dispatch('usuario/inactivar', usuarioId)
        .then(() => {
          this.showModalMsj('La cuenta de usuario seleccionada se inactivó con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
    password (item) {
      this.showModalConfirm('¿Desea solicitar el restablecimiento de la contraseña del usuario seleccionado?', 
            this.forgotPassword.bind(this, item.id), 'Si', null, 'No');
    },
    forgotPassword (usuarioId) {
      this.showSpinner();
      this.$store.dispatch('usuario/forgotPassword', usuarioId)
        .then(() => this.showModalMsj('Se envió un email al usuario para restablecer su contraseña.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    reenviar (item) {
      this.showModalConfirm('¿Desea reenviar la invitación al usuario para completar el registro?', 
            this.reenviarRegistro.bind(this, item.id), 'Si', null, 'No');
    },
    reenviarRegistro(usuarioId) {
      this.showSpinner();
      this.$store.dispatch('usuario/sendInvite', usuarioId)
        .then(() => this.showModalMsj('Se envió la invitación al usuario para completar el registro.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .usuarios .registro table td[aria-colindex="1"] {
    width: Calc(40% - 15px);
  }
  .usuarios .registro table td[aria-colindex="2"] {
    width: Calc(40% - 15px);
  }
  .usuarios .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .usuarios .registro table td[aria-colindex="4"] {
    width: 30px;
  }
</style>
